// extracted by mini-css-extract-plugin
export default {"widget":"widget_widget__1gkjM","widget--half-size":"widget_widget--half-size__-fq6m","body":"widget_body__VL9E6","widget--scrolling":"widget_widget--scrolling__cGBie"};